;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.controllers')
    .controller('LedgerController', LedgerController)

  LedgerController.$inject = [
    // Angular
    '$uibModalInstance',

    // Services
    'DatePickerService'

  ]

  function LedgerController (
    // Angular
    $uibModalInstance,

    // Services
    DatePickerService

  ) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        period: {},
        // Public Method
        setFromDate: setFromDate,
        setToDate: setToDate,
        cancel: cancel,
        accept: accept
      })
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function accept () {
      $uibModalInstance.close(self.period)
    }

    function setFromDate () {
      DatePickerService.getRange(self.period.from).then(function (date) {
        date.utcOffset(0, true)
        self.period.from = new Date(date)
        self.theForm.$dirty = true
      })
    }

    function setToDate () {
      DatePickerService.getRange(self.period.to).then(function (date) {
        date.utcOffset(0, true)
        self.period.to = new Date(date)
        self.theForm.$dirty = true
      })
    }
  }
})(window.angular, window._)
